import type { TrajeCor, TrajeDoc, TrajeExclusiva, TrajePeca, TrajeSlot } from '../api/types';
import { overlayDoPack } from '../world/spriteAtlas';

/** O catálogo que o fio precisa (vem no TrajeDto). */
export interface CatalogoDoTraje {
  readonly slots: readonly TrajeSlot[];
  readonly pecas: readonly TrajePeca[];
  readonly cores: readonly TrajeCor[];
  /** As peças exclusivas do personagem (a Capa do Balron): a arte da capa na matiz fixa. */
  readonly exclusivas?: readonly TrajeExclusiva[];
}

type Vestido = { readonly equippedSlot?: string | null; readonly defId: string };

/** Armadura visível por baixo do traje, por slot do equipamento — o mesmo do TrajeVisual.cs (o traje vale sempre). */
function aMostra(doc: TrajeDoc, slot: string): boolean {
  const m = doc.mostrar;
  if (slot === 'helm') return m.elmo;
  if (slot === 'chest' || slot === 'arms') return m.peito;
  if (slot === 'gloves') return m.luvas;
  if (slot === 'legs') return m.pernas;
  return true;   // o robe vestido (slot de roupa) sempre aparece
}

/**
 * O fio do visual com o traje, igual ao que o servidor monta (TrajeVisual.Montar): o equipamento à mostra e depois
 * as peças, `t:<peça>:<matiz>`. O provador usa para mostrar o traje antes de vestir.
 */
export function clothDoTraje(doc: TrajeDoc, cat: CatalogoDoTraje, feminino: boolean, itens: readonly Vestido[]): string {
  const vestidos = itens.filter(i => !!i.equippedSlot);
  const partes: string[] = [];
  const armadura = overlayDoPack(vestidos.filter(i => aMostra(doc, i.equippedSlot ?? '')));
  if (armadura) partes.push(armadura);
  const elmoAMostra = doc.mostrar.elmo && vestidos.some(i => i.equippedSlot === 'helm');
  for (const slot of cat.slots) {
    const e = doc.pecas[slot.id];
    if (!e?.peca) continue;
    const exclusiva = cat.exclusivas?.find(x => x.id === e.peca);
    if (exclusiva?.set) {
      // A skin (techspec-skins §03): a de cor fixa vai com matiz 0; a tingível, com a da cor escolhida. A do cajado o
      // motor só pinta sobre uma maça.
      if (slot.id !== exclusiva.slot || (exclusiva.soMulher && !feminino)) continue;
      if (slot.id === 'cabeca' && elmoAMostra) continue;
      // A tingível na Natural (hue 0) cai na matiz própria da skin: o Shroud Robe fica no roxo do Vazio (1158).
      const matiz = (exclusiva.tingivel ? cat.cores.find(c => c.id === e.cor)?.hue || 0 : 0) || exclusiva.hue || 0;
      partes.push(`t:${exclusiva.id}:${matiz}`);
      continue;
    }
    if (exclusiva) {
      if (slot.id === exclusiva.slot) partes.push(`t:${exclusiva.slot}:${exclusiva.hue}`);
      continue;
    }
    const peca = cat.pecas.find(p => p.id === e.peca);
    if (!peca || peca.slot !== slot.id) continue;
    if (peca.soMulher && !feminino) continue;
    if (slot.id === 'cabeca' && elmoAMostra) continue;
    const hue = cat.cores.find(c => c.id === e.cor)?.hue ?? 0;
    partes.push(`t:${peca.id}:${hue}`);
  }
  return partes.join('+');
}
